import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import CustomCursor from "@/components/CustomCursor";

const sections = [
  {
    title: "1. Responsable du traitement",
    content: `Mirror Digital, joignable à l'adresse contact@mirrordigital.cloud, est responsable du traitement de vos données personnelles collectées via le site mirrordigital.cloud.`,
  },
  {
    title: "2. Données collectées",
    content: `Nous collectons les données suivantes : nom, prénom, adresse e-mail, données de profil professionnel (liens LinkedIn, bio, etc.), données d'utilisation du service. Ces données sont collectées lors de votre inscription, de l'utilisation de nos fonctionnalités ou lorsque vous nous contactez.`,
  },
  {
    title: "3. Finalités du traitement",
    content: `Vos données sont utilisées pour : fournir et améliorer nos services, personnaliser votre expérience, vous envoyer des communications relatives à votre compte, assurer la sécurité de la plateforme, respecter nos obligations légales.`,
  },
  {
    title: "4. Base légale",
    content: `Le traitement de vos données repose sur : l'exécution du contrat (fourniture du service), votre consentement (communications marketing), notre intérêt légitime (amélioration du service, sécurité), et le respect de nos obligations légales.`,
  },
  {
    title: "5. Conservation des données",
    content: `Vos données sont conservées pendant la durée de votre utilisation du service, puis pendant 3 ans à compter de la fin de la relation contractuelle à des fins de gestion des litiges et obligations légales. Les données de connexion sont conservées 12 mois conformément à la loi.`,
  },
  {
    title: "6. Partage des données",
    content: `Vos données peuvent être partagées avec nos sous-traitants techniques (hébergement, paiement via Stripe, envoi d'emails via Resend) dans le cadre strict de la fourniture du service. Nous ne vendons jamais vos données à des tiers.`,
  },
  {
    title: "7. Vos droits",
    content: `Conformément au RGPD, vous disposez des droits suivants : accès, rectification, effacement, limitation du traitement, portabilité, opposition. Pour exercer ces droits, contactez-nous à contact@mirrordigital.cloud. Vous pouvez également déposer une réclamation auprès de la CNIL (www.cnil.fr).`,
  },
  {
    title: "8. Cookies",
    content: `Nous utilisons des cookies strictement nécessaires au fonctionnement du service (authentification, préférences). Aucun cookie publicitaire ou de tracking tiers n'est utilisé sans votre consentement explicite.`,
  },
  {
    title: "9. Sécurité",
    content: `Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données : chiffrement HTTPS, hachage des mots de passe, accès restreint aux données.`,
  },
];

export default function Privacy() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: "100vh",
      background: "#080b14",
      color: "white",
      fontFamily: "'Syne', sans-serif",
      position: "relative",
      overflow: "hidden",
    }}>
        <CustomCursor /> 
      {/* Background glow */}
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none", zIndex: 0 }}>
        <div style={{
          position: "absolute", top: "-20%", left: "30%",
          width: 600, height: 400,
          background: "radial-gradient(ellipse, rgba(6,182,212,0.1) 0%, transparent 70%)",
        }} />
        <div style={{
          position: "absolute", bottom: "5%", right: "5%",
          width: 500, height: 300,
          background: "radial-gradient(ellipse, rgba(124,58,237,0.08) 0%, transparent 70%)",
        }} />
      </div>

      {/* Nav */}
      <motion.nav
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        style={{
          position: "fixed", top: 0, left: 0, right: 0, zIndex: 50,
          padding: "18px 32px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
          borderBottom: "1px solid rgba(255,255,255,0.06)",
          background: "rgba(8,11,20,0.85)",
          backdropFilter: "blur(12px)",
        }}
      >
        <button onClick={() => navigate("/")} style={{
          display: "flex", alignItems: "center", gap: 9, background: "none", border: "none", cursor: "pointer",
        }}>
          <div style={{
            width: 32, height: 32, borderRadius: 8,
            background: "linear-gradient(135deg,#7c3aed,#06b6d4)",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: "0 0 14px rgba(124,58,237,0.5)",
          }}>
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </div>
          <span style={{ fontWeight: 800, color: "white", fontSize: 13, letterSpacing: "0.06em" }}>MirrorDigital</span>
        </button>
        <button onClick={() => navigate(-1)} style={{
          background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)",
          color: "rgba(255,255,255,0.6)", padding: "7px 16px", borderRadius: 8,
          cursor: "pointer", fontSize: 13, fontFamily: "'Syne', sans-serif",
        }}>← Retour</button>
      </motion.nav>

      {/* Content */}
      <div style={{ maxWidth: 760, margin: "0 auto", padding: "120px 24px 80px", position: "relative", zIndex: 1 }}>
        <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div style={{
            display: "inline-block", marginBottom: 16,
            padding: "5px 14px", borderRadius: 20,
            background: "rgba(6,182,212,0.12)", border: "1px solid rgba(6,182,212,0.3)",
            fontSize: 12, color: "#67e8f9", letterSpacing: "0.1em", fontWeight: 700,
          }}>CONFIDENTIALITÉ</div>

          <h1 style={{
            fontSize: "clamp(32px, 5vw, 52px)", fontWeight: 900,
            lineHeight: 1.1, marginBottom: 16,
            background: "linear-gradient(135deg, #fff 0%, rgba(255,255,255,0.6) 100%)",
            WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
          }}>Politique de confidentialité</h1>

          <p style={{ color: "rgba(255,255,255,0.4)", fontSize: 14, marginBottom: 56 }}>
            Dernière mise à jour : mai 2026 · Conforme au RGPD
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
            {sections.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.08 * i, duration: 0.5 }}
                style={{
                  padding: "28px 32px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.07)",
                  borderRadius: 16,
                  borderLeft: "3px solid rgba(6,182,212,0.5)",
                }}
              >
                <h2 style={{ fontSize: 17, fontWeight: 800, marginBottom: 12, color: "white" }}>{s.title}</h2>
                <p style={{ fontSize: 14, lineHeight: 1.8, color: "rgba(255,255,255,0.55)" }}>{s.content}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}